import { Badge } from "reactstrap";
import i18n from "../../../i18n";

export function printOrderStatus(status) {
  switch (status) {
    case 'draft':
      return <Badge color="secondary">{i18n.t('common.draft')}</Badge>;
    case 'sent':
      return <Badge color="info">{i18n.t('common.sent')}</Badge>;
    case 'approved':
      return <Badge color="warning">{i18n.t('common.approved')}</Badge>;
    case 'received':
      return <Badge color="success">{i18n.t('common.received')}</Badge>;
    case 'canceled':
      return <Badge color="danger">{i18n.t('common.canceled')}</Badge>;
    default:
      return <Badge color="dark">{i18n.t('common.unknownStatus')}</Badge>;
  }
}

export function printBillStatus(status) {
  switch (status) {
    case 'unpaid':
      return <Badge color="danger">{i18n.t('common.unpaid')}</Badge>;
    case 'partially_paid':
      return <Badge color="warning">{i18n.t('common.partiallyPaid')}</Badge>;
    case 'paid':
      return <Badge color="success">{i18n.t('common.paid')}</Badge>;
    default:
      return <Badge color="dark">{i18n.t('common.unknownStatus')}</Badge>;
  }
}
